import { render, staticRenderFns } from "./add-screen.vue?vue&type=template&id=00336c2c"
import script from "./add-screen.vue?vue&type=script&lang=js"
export * from "./add-screen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports